<template>
  <div>
    <StandingsSection />
  </div>
</template>

<script setup lang="ts">
import StandingsSection from '@/components/StandingsSection.vue';

useHead({
  title: 'Current Pool League Standings | The Players League DFW Rankings',
  meta: [
    { name: 'description', content: 'Check the latest team and player standings for The Players League DFW. Stay updated with current rankings, wins, losses, and points.' },
    { property: 'og:title', content: 'Current Pool League Standings | The Players League DFW Rankings' },
    { property: 'og:description', content: 'Check the latest team and player standings for The Players League DFW. Stay updated with current rankings, wins, losses, and points.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://theplayersleaguedfw.com/standings' },
    { property: 'og:image', content: 'https://theplayersleaguedfw.com/TPLDFW-logo.JPEG' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: 'Current Pool League Standings | The Players League DFW Rankings' },
    { name: 'twitter:description', content: 'Check the latest team and player standings for The Players League DFW. Stay updated with current rankings, wins, losses, and points.' },
    { name: 'twitter:image', content: 'https://theplayersleaguedfw.com/TPLDFW-logo.JPEG' }
  ]
});
</script>

<style scoped>
</style>
